<template>
  <div>
    <div class="page-wrapper">
      <div class="">
        <div
          class="page-content"
          v-show="accessObject?.is_view == 1 || !isShowAccessDeniedMessage">
          <div class="card-body py-0 px-2">
            <div class="mb-0 radius-15 mr-broad-list-wrapper">
              <!-- card border -->
              <div class="row tablefix">
                <div class="col-lg-2 col-sm-2 pr-2 my-auto">
                  <span class="pull-left">
                    <a
                      class="pr-2 text-dark cursor-pointer"
                      v-on:click="$router.go(-1)"
                      ><span class="font-24 mr-2"
                        ><img src="/images/back-arrow.svg" width="18"
                      /></span>
                    </a>
                  </span>
                  <span class="has-search pull-left" style="width: 80%">
                    <!-- <span class="bx bx-search form-control-feedback"></span> -->
                    <i
                      class="fa fa-search"
                      style="position: absolute; margin: 10px"
                      aria-hidden="true"></i>
                    <input
                      type="text"
                      style="height: 43px"
                      class="form-control"
                      placeholder="Search "
                      v-model="searchObj.keyword"
                      v-on:keyup.enter="getList(0)" />
                  </span>
                </div>
                <div class="col-lg-2 col-sm-2 my-auto">
                  <div class="styled-select">
                    <select
                      class="form-control"
                      v-on:change="getList(0)"
                      v-model="searchObj.membership_plan_id"
                      name=""
                      aria-required="true"
                      placeholder="Select Plan"
                      aria-invalid="false">
                      <option value="" disabled selected="selected">
                        Select Plan
                      </option>
                      <option value="FREE_MEMBER">Free Member</option>
                      <option
                        v-for="(data, index) in planList"
                        :key="index"
                        :value="data.uuid">
                        {{ data.name }}
                      </option>
                    </select>
                    <span
                      class="bx bx-chevron-down"
                      style="top: 6px; right: 8px"></span>
                  </div>
                </div>
                <div class="col-lg-5 col-sm-4 my-auto">
                  <a
                    style="display: inline-block; width: 90px"
                    class="fill-btn btn-style cursor-pointer"
                    v-on:click="getList(0)"
                    >Search</a
                  >
                  <a
                    style="display: inline-block; width: 90px"
                    class="fill-btn btn-style cursor-pointer"
                    v-on:click="resetFilter()"
                    >Reset</a
                  >
                  <span style="font-weight: Bold" class="mr-3">
                    Gun Milan:{{ gun_milan ? gun_milan : "0" }}
                  </span>

                  <span style="font-weight: Bold" class="mr-3">
                    Dosh kramank :
                    {{
                      dosh_kramank
                        ? dosh_kramank.length > 1 && dosh_kramank != "NA"
                          ? dosh_kramank
                          : dosh_kramank
                        : "0"
                    }}
                  </span>

                  <span style="font-weight: Bold" class="">
                    Mangal : {{ is_mangal ? is_mangal : "NA" }}
                  </span>
                </div>
                <div class="col-lg-3 col-sm-4">
                  <div class="text-last">
                   <div>
                      <ul class="navbar-nav">
                        <li class="nav-item dropdown dropdown-user-profile">
                          <a
                            class="nav-link dropdown-toggle dropdown-toggle-nocaret pr-0"
                            style="border-color: white; outline: 0"
                            data-toggle="dropdown">
                            <a class="fill-btn btn-style cursor-pointer"
                              ><i class="fa fa-paper-plane"></i>&nbsp; Send To
                              Account</a
                            >
                          </a>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                               v-on:click="sendToAccount('ONEWAY')"
                              class="dropdown-item cursor-pointer">
                              <!-- <i class="bx bx-user"></i> -->
                              <span
                                ><i class="fa fa-paper-plane"></i>&nbsp;Send One Way
                              </span>
                            </a>
                             <a
                               v-on:click="sendToAccount('TWOWAY')"
                              class="dropdown-item cursor-pointer">
                              <!-- <i class="bx bx-user"></i> -->
                              <span
                                ><i class="fa fa-paper-plane"></i>&nbsp;Send Two Way
                              </span>
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div>
                      <ul class="navbar-nav">
                        <li class="nav-item dropdown dropdown-user-profile">
                          <a
                            class="nav-link dropdown-toggle dropdown-toggle-nocaret pr-0"
                            style="border-color: white; outline: 0"
                            data-toggle="dropdown">
                            <a class="fill-btn btn-style cursor-pointer"
                              ><i class="fa fa-download"></i>&nbsp; Download
                              PDF</a
                            >
                          </a>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              v-on:click="downloadProfile()"
                              class="dropdown-item cursor-pointer">
                              <!-- <i class="bx bx-user"></i> -->
                              <span
                                ><i class="fa fa-download"></i>&nbsp;Personal
                                Bio-Data
                              </span>
                            </a>
                            <div
                              class="dropdown-divider mb-0 cursor-pointer"></div>
                            <a
                              :class="
                                suggested_user_ids.length == 0
                                  ? 'cursor-drop'
                                  : 'cursor-pointer'
                              "
                              :style="
                                suggested_user_ids.length == 0
                                  ? 'opacity: 0.5;'
                                  : 'opacity: 1'
                              "
                              v-on:click="
                                suggested_user_ids.length == 0
                                  ? ''
                                  : getSuggestedUsersDetailPdf()
                              "
                              class="dropdown-item">
                              <!-- <i class="bx bx-user"></i> -->
                              <span
                                ><i class="fa fa-download"></i>&nbsp;Suggested
                                Detailed Bio-Data (All Details)
                              </span>
                            </a>
                            <div
                              class="dropdown-divider mb-0 cursor-pointer"></div>
                            <a
                              :class="
                                suggested_user_ids.length == 0
                                  ? 'cursor-drop'
                                  : 'cursor-pointer'
                              "
                              :style="
                                suggested_user_ids.length == 0
                                  ? 'opacity: 0.5;'
                                  : 'opacity: 1'
                              "
                              v-on:click="
                                suggested_user_ids.length == 0
                                  ? ''
                                  : downloadPdf()
                              "
                              class="dropdown-item">
                              <!-- <i class="bx bx-user"></i> -->
                              <span
                                ><i class="fa fa-download"></i>&nbsp;Summary
                                List</span
                              >
                            </a>
                            <div
                              class="dropdown-divider mb-0 cursor-pointer"></div>
                            <a
                              :class="
                                suggested_user_ids.length == 0
                                  ? 'cursor-drop'
                                  : 'cursor-pointer'
                              "
                              :style="
                                suggested_user_ids.length == 0
                                  ? 'opacity: 0.5;'
                                  : 'opacity: 1'
                              "
                              v-on:click="
                                suggested_user_ids.length == 0
                                  ? ''
                                  : getSuggestedUsersDetailWithoutContactPdf()
                              "
                              class="dropdown-item">
                              <!-- <i class="bx bx-user"></i> -->
                              <span
                                ><i class="fa fa-download"></i>&nbsp; Suggested
                                Detailed Bio-Data (Without Contact
                                Details)</span
                              >
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pt40">
                <div
                  class="col-lg-12 col-sm-12 my-2"
                  v-if="detail && detail.id">
                  <span
                    class="mb-0 cursor-pointer"
                    style="
                      color: rgb(232, 62, 140);
                      font-size: 20px;
                      font-weight: Bold;
                    "
                    v-on:click="
                      goToUrl(
                        detail.id,
                        '/view-user-detail/' + detail.uuid + '/BROAD'
                      )
                    ">
                    Matches for {{ detail.registration_no }} |
                  </span>
                  <span>
                    <img
                      :src="detail.image ? detail.image : '/img/user-pic.png'"
                      class="user-img"
                      alt=""
                      id="loginuser-image"
                  /></span>
                  <span style="font-size: 20px; font-weight: Bold">
                    {{ detail.first_name }} {{ detail.last_name }} |
                  </span>

                  <span style="font-size: 20px; font-weight: Bold">
                    {{
                      (detail.dob
                        ? $helperService.getNewFormatedDate(detail.dob) + " | "
                        : "") +
                      (detail.height
                        ? $helperService.getHeight(detail.height) + " | "
                        : "") +
                      (detail.annual_income
                        ? this.$helperService.kFormatter(detail.annual_income) +
                          " | "
                        : "") +
                      (detail.blood_group ? detail.blood_group + " | " : "") +
                      (detail.personality
                        ? detail.personality.name + " | "
                        : "") +
                      (detail.family_details && detail.family_details.eco_status
                        ? detail.family_details.eco_status.name + " | "
                        : "") +
                      (detail.family_details && detail.family_details.relation
                        ? detail.family_details.relation.name + " | "
                        : "")
                    }}
                  </span>
                </div>
              </div>
              <div>
                <div class="card mb-0 radius-15 custom-table">
                  <div class="card-body p-0 pb-4">
                    <div class="table-responsive" style="white-space: initial">
                      <div class="dataTables_wrapper dt-bootstrap4">
                        <div class="tableFixHead">
                          <table
                            class="table table-striped table-bordered"
                            style="width: 100%"
                            role="grid"
                            aria-describedby="example_info">
                            <thead>
                              <tr role="row">
                                <th></th>
                                <th
                                  class="sorting"
                                  id="id-Pay"
                                  v-on:click="sorting('users.id', 'id-Pay')">
                                  <div>
                                    ID<br />1st Pay Dt<br />Lat. Pay Date<br />Amount
                                  </div>
                                </th>
                                <th>
                                  <div>Full Name<br />Photo</div>
                                </th>
                                <th
                                  class="sorting"
                                  id="id-minus_point"
                                  v-on:click="
                                    sorting(
                                      'users.minus_point',
                                      'id-minus_point'
                                    )
                                  ">
                                  <div>MP</div>
                                </th>
                                <th
                                  class="sorting famwidth1"
                                  id="id-native_tal"
                                  v-on:click="
                                    sorting(
                                      'native_taluka.name',
                                      'id-native_tal'
                                    )
                                  ">
                                  <div>
                                    Native Gaon Tal. Dist. |<br />Family Res.<br />Gaon
                                    Tal. Dist.
                                  </div>
                                </th>
                                <th
                                  class="dobiswidth sorting"
                                  id="id-height"
                                  v-on:click="
                                    sorting('users.height', 'id-height')
                                  ">
                                  <div>
                                    DOB | Ht | Skin T. |<br />Body Str. |<br />BG
                                    | Per.
                                  </div>
                                </th>
                                <th>
                                  <div>
                                    Raas | Nakshtra | Charan <br />| Nadi | Gan
                                    | Mangal | Devak
                                  </div>
                                </th>
                                <th
                                  class="edWidth sorting"
                                  id="id-working_place_taluka_name"
                                  v-on:click="
                                    sorting(
                                      'working.name',
                                      'id-working_place_taluka_name'
                                    )
                                  ">
                                  <div>
                                    Education<br />Occu.<br />Work Location<br />Inc.
                                  </div>
                                </th>
                                <th>
                                  <!-- class="prowidth"-->
                                  <div>Properties with Place<br />| ES</div>
                                </th>
                                <th>
                                  <div>
                                    Father Occu.|<br />Mother Occu. |<br />
                                    Bro/Sis
                                  </div>
                                </th>
                                <th class="mamawid">
                                  <div>
                                    Mama (Surname)<br />| Relatives with<br />Gaon
                                    <!-- | Rrelation
                                     -->
                                  </div>
                                </th>
                                <th
                                  class="expwidth sorting"
                                  id="id-SD"
                                  v-on:click="
                                    sorting(
                                      'handpick_suggestions.created_at',
                                      'id-SD'
                                    )
                                  ">
                                  <div>
                                    Expectations|<br />Patrika |<br />SD
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody v-show="!loader">
                              <tr v-for="(data, index) in list" :key="index">
                                <td
                                  @click="
                                    sendToSuggestion(
                                      data,
                                      data.is_checked,
                                      index
                                    )
                                  "
                                  style="cursor: pointer"
                                  :id="'broad_' + data.id"
                                  :style="
                                    data.is_membership_subscribed == null ||
                                    data.is_membership_subscribed == 'N'
                                      ? 'background-color: rgb(210, 242, 210);'
                                      : 'white'
                                  ">
                                  <div class="switchToggleRead">
                                    <input
                                      :key="'index_' + index + '_' + data.id"
                                      :id="'index_' + data.id"
                                      type="checkbox"
                                      v-model="data.isChecked"
                                      :true-value="true"
                                      :false-value="false"
                                      @click.stop="
                                        sendToSuggestion(
                                          data,
                                          data.is_checked,
                                          index
                                        )
                                      " />
                                  </div>
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{ data.registration_no }}</span
                                  >
                                  <div>
                                    <span
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      ">
                                      {{
                                        data.first_pay_date
                                          ? $helperService.getFormatedDateNew(
                                              data.first_pay_date
                                            )
                                          : "-"
                                      }}</span
                                    >
                                  </div>
                                  <div>
                                    <span
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      ">
                                      {{
                                        data.last_pay_date
                                          ? $helperService.getFormatedDateNew(
                                              data.last_pay_date
                                            )
                                          : "-"
                                      }}</span
                                    >
                                  </div>
                                  <div>
                                    <span
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      ">
                                      {{
                                        data.amount
                                          ? $helperService.kThousandFormatter(
                                              data.amount
                                            )
                                          : "0k"
                                      }}</span
                                    >
                                  </div>
                                </td>
                                <td
                                  style="
                                    word-break: break-all !important;
                                    word-wrap: break-word;
                                    color: #bd1c9c;
                                  "
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    <a>
                                      {{ data.first_name }}
                                      {{ data.middle_name }}
                                      {{ data.last_name }}</a
                                    >
                                  </span>
                                  <div class="">
                                    <img
                                      class="picWidth"
                                      @click="viewImage(data.image)"
                                      :src="
                                        data.image
                                          ? data.image
                                          : '/images/user-pic.png'
                                      "
                                      width="40"
                                      height="40" />
                                  </div>
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{ data.minus_point }}</span
                                  >
                                </td>
                                <td
                                  style="
                                    word-break: break-all !important;
                                    word-wrap: break-word;
                                    color: #bd1c9c;
                                  "
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.native_place_goan
                                        ? data.native_place_goan + ", "
                                        : " - "
                                    }}
                                    {{
                                      data.native_place_taluka
                                        ? data.native_place_taluka.name + ", "
                                        : " - "
                                    }}
                                    {{
                                      data.native_place_district
                                        ? data.native_place_district.name + ", "
                                        : " - "
                                    }}

                                    |
                                    <br />
                                    {{ data.goan ? data.goan + ", " : "" }}
                                    {{
                                      data.family_details &&
                                      data.family_details.taluka
                                        ? data.family_details.taluka.name + ", "
                                        : " - "
                                    }}
                                    {{
                                      data.family_details &&
                                      data.family_details.district
                                        ? " " +
                                          data.family_details.district.name +
                                          " "
                                        : " - "
                                    }}</span
                                  >
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <div>
                                    <span
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      ">
                                      {{
                                        data.dob
                                          ? $helperService.getFormatedDateNew(
                                              data.dob
                                            )
                                          : "-"
                                      }}
                                      <br />
                                      {{
                                        data.height
                                          ? $helperService.getHeight(
                                              data.height
                                            )
                                          : "-"
                                      }}
                                      <br />
                                      {{
                                        data.scan_tone && data.scan_tone.name
                                          ? data.scan_tone &&
                                            data.scan_tone.name
                                          : "-"
                                      }}
                                    </span>
                                  </div>
                                  <div>
                                    <span
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      ">
                                      {{
                                        data.body_structure &&
                                        data.body_structure.name
                                          ? data.body_structure &&
                                            data.body_structure.name
                                          : "-"
                                      }}
                                      <br />
                                      {{
                                        data.blood_group
                                          ? data.blood_group
                                          : "-"
                                      }}
                                      <br />
                                      {{
                                        data.personality &&
                                        data.personality.name
                                          ? data.personality &&
                                            data.personality.name
                                          : "-"
                                      }}</span
                                    >
                                  </div>
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  class="cursor-pointer"
                                  v-on:click="kundliMilan(data.uuid, uuid)"
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <div>
                                    <span
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      ">
                                      {{ data.gun ? data.gun : "-" }} |
                                      {{
                                        data.raas && data.raas.name
                                          ? data.raas && data.raas.name
                                          : "-"
                                      }}
                                      |
                                      {{
                                        data.nakshatra && data.nakshatra.name
                                          ? data.nakshatra &&
                                            data.nakshatra.name
                                          : "-"
                                      }}
                                      |
                                      {{
                                        data.charan && data.charan.name
                                          ? data.charan && data.charan.name
                                          : "-"
                                      }}
                                      |</span
                                    >
                                  </div>
                                  <div>
                                    <span
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      ">
                                      {{
                                        data.nadi && data.nadi.name
                                          ? data.nadi && data.nadi.name
                                          : "-"
                                      }}
                                      |
                                      {{
                                        data.gan && data.gan.name
                                          ? data.gan && data.gan.name
                                          : "-"
                                      }}
                                      |
                                      {{
                                        data.is_mangal
                                          ? data.is_mangal == "Y"
                                            ? "Yes"
                                            : data.is_mangal == "N"
                                            ? "NO"
                                            : data.is_mangal.replaceAll(
                                                "_",
                                                " "
                                              )
                                          : "-"
                                      }}
                                      |
                                      {{ data.devak ? data.devak : "-" }}</span
                                    >
                                  </div>
                                </td>
                                <td
                                  v-on:click="
                                    goToUrl(
                                      data.id,
                                      '/view-user-detail/' +
                                        data.uuid +
                                        '/BROAD'
                                    )
                                  "
                                  style="
                                    word-break: break-all !important;
                                    word-wrap: break-word;
                                    cursor: pointer;
                                    color: #bd1c9c;
                                  "
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <div>
                                    <span
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      ">
                                      {{
                                        data.education_courses
                                          ? data.education_courses
                                          : "-"
                                      }}
                                      |
                                      {{
                                        data.occupation_type &&
                                        data.occupation_type.name
                                          ? data.occupation_type &&
                                            data.occupation_type.name
                                          : "-"
                                      }}
                                      |
                                    </span>
                                  </div>
                                  <div>
                                    <span
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      ">
                                      {{
                                        data.working_place_taluka &&
                                        data.working_place_taluka.name
                                          ? data.working_place_taluka.name +
                                            ", "
                                          : "-"
                                      }}
                                      {{
                                        data.working_place_goan
                                          ? data.working_place_goan
                                          : ""
                                      }}
                                      |</span
                                    >
                                  </div>
                                  <div>
                                    <span
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      ">
                                      {{
                                        data.annual_income
                                          ? this.$helperService.kFormatter(
                                              data.annual_income
                                            )
                                          : "-"
                                      }}</span
                                    >
                                  </div>
                                </td>
                                <td
                                  style="
                                    word-break: break-all !important;
                                    word-wrap: break-word;
                                    color: #bd1c9c;
                                  "
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <div
                                    v-for="(data1, index) in data.properties"
                                    :key="index">
                                    <div>
                                      <span
                                        :style="
                                          data.color_code
                                            ? 'color:' + data.color_code
                                            : ''
                                        ">
                                        {{
                                          data1.details
                                            ? data1.details + " , "
                                            : "-"
                                        }}
                                        {{
                                          data1.place
                                            ? data1.place + " | "
                                            : "-"
                                        }}</span
                                      >
                                    </div>
                                  </div>
                                  |
                                  <div
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.family_details &&
                                      data.family_details.eco_status &&
                                      data.family_details.eco_status.name
                                        ? data.family_details.eco_status.name
                                        : "-"
                                    }}
                                  </div>
                                </td>
                                <td
                                  style="
                                    word-break: break-all !important;
                                    word-wrap: break-word;
                                    color: #bd1c9c;
                                  "
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <div>
                                    <span
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      ">
                                      {{
                                        data.family_details &&
                                        data.family_details.father_occuption
                                          ? data.family_details &&
                                            data.family_details.father_occuption
                                          : "-"
                                      }}
                                      |</span
                                    >
                                  </div>
                                  <div>
                                    <span
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      ">
                                      {{
                                        data.family_details &&
                                        data.family_details.mother_occuption
                                          ? data.family_details &&
                                            data.family_details.mother_occuption
                                          : "-"
                                      }}
                                      |</span
                                    >
                                  </div>
                                  <div v-if="data.family_details">
                                    <div
                                      v-for="(data1, index) in data
                                        .family_details.family_members"
                                      :key="index">
                                      <div>
                                        <span
                                          :style="
                                            data.color_code
                                              ? 'color:' + data.color_code
                                              : ''
                                          ">
                                          {{ data1.name ? data1.name : "" }}
                                          <br />
                                          {{
                                            data1.is_married == "Y"
                                              ? "-" + "Married"
                                              : data1.is_married == "N"
                                              ? "-" + "Unmarried"
                                              : "-" + data1.is_married
                                          }}
                                          |</span
                                        >
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td
                                  style="
                                    word-break: break-all !important;
                                    word-wrap: break-word;
                                    color: #bd1c9c;
                                  "
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <div>
                                    <span
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      ">
                                      {{
                                        (data.family_details &&
                                        data.family_details.mama_surname
                                          ? data.family_details.mama_surname.trim()
                                          : "-") +
                                        (data.family_details &&
                                        data.family_details.mama_taluka_place
                                          ? "-" +
                                            data.family_details.mama_taluka_place.trim()
                                          : "")
                                      }}
                                      |
                                    </span>
                                  </div>
                                  <div v-if="data.family_details">
                                    <div
                                      v-for="(data1, index) in data
                                        .family_details.relatives"
                                      :key="index">
                                      <div>
                                        <span
                                          :style="
                                            data.color_code
                                              ? 'color:' + data.color_code
                                              : ''
                                          ">
                                          {{
                                            data1.surname
                                              ? data1.surname + "-"
                                              : ""
                                          }}
                                          {{
                                            data1.goan ? data1.goan + "," : ""
                                          }}</span
                                        >
                                      </div>
                                    </div>
                                  </div>
                                  <!-- |
                                  <div>
                                    {{
                                      data.relation_name
                                        ? data.relation_name
                                        : "-"
                                    }}
                                  </div> -->
                                </td>
                                <!-- <td
                                v-on:click="
                                    goToUrl(data.id, '/view-user/' + data.uuid)
                                  "
                                  style="cursor: pointer"
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  "
                                >
                                  <span style="color: blue"> View</span>
                                </td> -->
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                    v-if="
                                      data.expectation &&
                                      data.expectation
                                        .occupation_other_expectations
                                    ">
                                    {{
                                      data.expectation &&
                                      data.expectation
                                        .occupation_other_expectations
                                        ? " " +
                                          data.expectation
                                            .occupation_other_expectations
                                        : ""
                                    }}
                                  </span>
                                  |
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                    v-if="
                                      data.expectation &&
                                      data.expectation.patrika_match
                                    "
                                    ><br />
                                    {{
                                      data.expectation &&
                                      data.expectation.patrika_match
                                        ? data.expectation.patrika_match == "Y"
                                          ? "YES "
                                          : data.expectation.patrika_match ==
                                            "N"
                                          ? "NO "
                                          : data.expectation.patrika_match ==
                                            "ALL"
                                          ? "Flexible"
                                          : ""
                                        : ""
                                    }}
                                  </span>

                                  <span
                                    v-if="
                                      data.expectation &&
                                      data.expectation.patrika_match
                                    "></span>
                                  |
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.suggested_date
                                        ? " " +
                                          $helperService.getFormatedDateNew(
                                            data.suggested_date
                                          )
                                        : "-"
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="row mx-0 mb-4">
                            <div class="col-lg-12 mt-2 text-center">
                              <div class="page-bottom-pagination text-right">
                                <Pagination
                                  @page-change="pageChange"
                                  @items-per-page-change="itemsPerPageChange"
                                  ref="listPagination" />
                              </div>
                            </div>
                          </div>
                          <ErrorComponent
                            @retry="getList(0)"
                            ref="errorComponent" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div style="display: none">
                <div class="mb-0 radius-15">
                  <div class="card-body p-0 pb-4">coming soon</div>
                </div>
              </div>
              <div class="row mx-0 mb-4">
                <div class="col-lg-12 mt-5 text-center">
                  <div class="page-bottom-pagination text-right">
                    <div>
                      
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <DeleteModal @remove="accept($event)" ref="hideModal" />
    <DeleteModal @remove="deleteRecord($event)" ref="deleteModal" />
    <TextModal ref="viewImage">
      <div
        class="modal-header border-0 d-block text-center"
        style="position: relative">
        <a
          class="close text-danger btn-pos"
          style="opacity: 1"
          v-on:click="$refs.viewImage.closeModal()">
          <img
            src="/images/close-btn.png"
            width="25"
            height="25"
            style="background: #fff; border-radius: 100px" />
        </a>
        <img
          :src="module_image"
          :id="compoentId"
          class="mg-fluid thumbnail-img profile-pic" />
      </div>
    </TextModal>
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import DeleteModal from "@/components/DeleteModal";
import TextModal from "@/components/TextModal.vue";
export default {
  name: "BroadList",
  components: {
    ErrorComponent,
    DeleteModal,
    Pagination,
    TextModal,
  },
  data() {
    return {
      gun_milan: "",
      module_image: "",
      dosh_kramank: "",
      is_mangal: "",
      accessObject: this.$helperService.getAccessLevel("Manage Users"),
      uuid: this.$route.params.uuid,
      loader: true,
      isShowAccessDeniedMessage: false,
      suggested_user_ids: [],
      searchObj: {
        keyword: "",
        membership_plan_id: "",
        uuid: this.$route.params.uuid,
        type: this.$route.params.type,
      },
      detail: {},
      count: 0,
      offset: -1,
      list: [],
      planList: [],
    };
  },
  mounted() {
    // if (!this.accessObject) {
    //   this.isShowAccessDeniedMessage = true;
    //   this.$router.push("/access-denied");
    //   return;
    // }
    this.getList(0);
    this.getPlanList();
    this.$helperService.showMenu("false");
  },
  methods: {
    viewImage(url) {
      if (url) {
        this.module_image = url;
        this.$refs.viewImage.showModal("HIDE");
      }
    },
    changeTab(tab) {
      this.currentTab = tab;
      this.searchObj.keyword = "";
      this.getList(0);
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    downloadProfile() {
      var url =
        this.$api.getBaseUrl() + "/get/biodata?uuid=" + this.detail.uuid;
      if (this.detail.uuid) {
        window.open(url);
      }
    },
    getPlanList() {
      this.$api
        .getAPI({
          _action: "/plan/list",
        })
        .then((res) => {
          this.planList = res.list;
        })
        .catch(() => {});
    },
    goToUrl(id, url) {
      var obj = {};
      obj.id = "broad_" + id;
      obj.offset = this.searchObj.offset;
      // this.$shareService.setMapValue("broad_lists", obj);
      // this.$router.push(url);
      window.open(
        url,
        "mywindow",
        "menubar=1,resizable=1,width=3500,height=1300"
      );
    },
    getList(page, orderBy, sortBy, type) {
      this.$refs.errorComponent.updateFormLoader(true);
      this.loader = true;
      // this.list = [];
      // this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      var shareobj = this.$shareService.getMapValue("broad_lists")
        ? this.$shareService.getMapValue("broad_lists")
        : null;
      this.searchObj.offset =
        shareobj && shareobj.offset ? shareobj.offset : page;
      this.$api
        .getAPI({
          _action: "/sugestion/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.detail = res.user;
          if (res.list && res.list.length > 0) {
            for (var i in res.list) {
              res.list[i].isChecked = false;
            }
          }
          this.list = res.list;
          this.count = res.count;
          this.offset = res.next_offset;
          if (this.suggested_user_ids && this.suggested_user_ids.length > 0) {
            setTimeout(() => {
              for (var k in res.list) {
                for (var j in this.suggested_user_ids) {
                  if (this.suggested_user_ids[j].uuid == res.list[k].uuid) {
                    res.list[k].is_checked = true;
                    document.getElementById(
                      "index_" + res.list[k].id
                    ).checked = true;
                  }
                }
              }
            }, 1000);
          } else if (type == "TYPE") {
            this.suggested_user_ids = [];
            for (var k in res.list) {
              res.list[k].is_checked = false;
              document.getElementById(
                "index_" + res.list[k].id
              ).checked = false;
            }
          }
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count, 50);
                this.$refs.listPagination.setCurrentPage(
                  this.searchObj.offset + 1
                );
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }

          if (shareobj && shareobj.id) {
            setTimeout(() => {
              document.getElementById(shareobj.id).scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
              });
            }, 100);
          } else {
            if (res.list && res.list.length > 0 && res.list[0].id) {
              setTimeout(() => {
                document
                  .getElementById("broad_" + res.list[0].id)
                  .scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest",
                  });
              }, 100);
            }
          }
          this.$shareService.setMapValue("broad_lists", null);
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No Broad List Available");
            this.$refs.errorComponent.updateFormLoader(false);
          }
          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },

    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.searchObj.membership_plan_id = "";
      this.getList(0);
    },
    sendToSuggestion(data, isChecked, index) {
      if (this.suggested_user_ids.length >= 200) {
        for (let u in this.list) {
          if (
            this.list[u].uuid == data.uuid &&
            this.list[u].is_checked == true
          ) {
            this.list[u].is_checked = false;
            for (let i in this.suggested_user_ids) {
              if (this.suggested_user_ids[i].uuid == data.uuid) {
                this.suggested_user_ids.splice(i, 1);
              }
            }
          }
        }
        // this.suggested_user_ids = [];
        for (let u in this.list) {
          if (this.list[u].is_checked == true) {
            var obj = {};
            obj.uuid = this.list[u].uuid;
            this.suggested_user_ids.push(obj);
          }
        }
        if (this.suggested_user_ids.length >= 200) {
          this.$notify({
            type: "error",
            text: "You can select maximum 200 users only.",
          });
        }
        document.getElementById("index_" + data.id).checked = false;
        this.suggested_user_ids = this.suggested_user_ids.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.uuid === item.uuid)
        );
        return;
      }
      var is_checked = !isChecked;

      if (is_checked) {
        document.getElementById("index_" + data.id).checked = true;
        this.list[index].is_checked = true;
      } else {
        document.getElementById("index_" + data.id).checked = false;
        this.list[index].is_checked = false;
        for (var i in this.suggested_user_ids) {
          if (this.suggested_user_ids[i].uuid == data.uuid) {
            this.suggested_user_ids.splice(i, 1);
          }
        }
      }
      // this.suggested_user_ids = [];
      for (var u in this.list) {
        if (this.list[u].is_checked == true) {
          let obj = {};
          obj.uuid = this.list[u].uuid;
          this.suggested_user_ids.push(obj);
        }
      }
      // Remove duplicate uuids from suggested_user_ids
      this.suggested_user_ids = this.suggested_user_ids.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.uuid === item.uuid)
      );
    },
    kundliMilan($user_id, $uuid) {
      this.gun_milan = "";
      this.dosh_kramank = "";
      this.is_mangal = "";
      var obj = {};
      obj.to_user_id = $user_id;
      obj.from_user_id = $uuid;
      this.$api
        .getAPI({
          _action: "/kundali/milan",
          _body: obj,
        })
        .then((res) => {
          console.log(res);
          this.gun_milan = res.gun_milan;
          if (res?.dosh_kramank != "NA") {
            this.dosh_kramank = res?.dosh_kramank?.toString();
            this.dosh_kramank = this.dosh_kramank?.replaceAll("", ",");
            this.dosh_kramank = this.dosh_kramank?.replace(/^,|,$/g, "");
          }
          this.is_mangal = res.is_mangal;
        })
        .catch(() => {});
    },

    sendToAccount(type) {
      if (this.suggested_user_ids.length == 0) {
        this.$notify({
          type: "error",
          text: "Please select atleast one user",
        });
        return;
      }
      this.$refs.errorComponent.updateFormLoader(true);
      var obj = {};
      obj.uuid = this.$route.params.uuid;
      obj.suggested_user_ids = this.suggested_user_ids;
      obj.type = type;
      this.$api
        .postAPI({
          _action: "/suggest",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.status,
          });
          // this.suggested_user_ids = [];
          this.$refs.errorComponent.updateFormLoader(false);
          this.getList(this.searchObj.offset, "", "", "TYPE");
        })
        .catch(() => {
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    downloadPdf() {
      var suggested_user_ids = [];
      for (var i in this.suggested_user_ids) {
        suggested_user_ids.push(this.suggested_user_ids[i].uuid);
      }
      var url =
        this.$api.getBaseUrl() +
        "/all/sugestion/broad/list?uuids=" +
        suggested_user_ids +
        "&uuid=" +
        this.uuid;
      console.log(url);
      window.open(url);
    },
    getSuggestedUsersDetailPdf() {
      var suggested_user_ids = [];
      for (var i in this.suggested_user_ids) {
        suggested_user_ids.push(this.suggested_user_ids[i].uuid);
      }
      var url =
        this.$api.getBaseUrl() +
        "/get/all/suggested/users/biodata?uuids=" +
        suggested_user_ids +
        "&uuid=" +
        this.uuid;

      window.open(url);
    },
    getSuggestedUsersDetailWithoutContactPdf() {
      // if (this.suggested_user_ids.length > 0) {
      //   var array = [];
      //   for (var i in this.suggested_user_ids) {
      //     array.push(this.suggested_user_ids[i].uuid);
      //   }
      //   var uuids = array.toString();
      // } else {
      //   this.$notify({
      //     type: "error",
      //     text: "Please select the user first to download pdf",
      //   });
      //   return;
      // }
      var suggested_user_ids = [];
      for (var i in this.suggested_user_ids) {
        suggested_user_ids.push(this.suggested_user_ids[i].uuid);
      }
      var url =
        this.$api.getBaseUrl() +
        "/get/all/suggested/users/biodata-without-contact?uuids=" +
        suggested_user_ids +
        "&uuid=" +
        this.uuid;
      window.open(url);
    },
  },
};
</script>

<style>
.custom-table table th,
.table-bordered thead th {
  border-right: 1px solid #ddd !important;
}
.tableFixHead thead th {
  font-size: 12px;
  line-height: 18px;
}
input[type="checkbox"],
input[type="radio"] {
  width: 20px;
  height: 18px;
}
</style>
